"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPoolState = exports.getPointDelta = exports.getFactoryContract = exports.getPoolContract = void 0;
const utils_1 = require("../base/utils");
const poolAbi_json_1 = __importDefault(require("./poolAbi.json"));
const factoryAbi_json_1 = __importDefault(require("./factoryAbi.json"));
const getPoolContract = (address, web3) => {
    return (0, utils_1.getEVMContract)(poolAbi_json_1.default, address, web3);
};
exports.getPoolContract = getPoolContract;
const getFactoryContract = (address, web3) => {
    return (0, utils_1.getEVMContract)(factoryAbi_json_1.default, address, web3);
};
exports.getFactoryContract = getFactoryContract;
const getPointDelta = (pool) => __awaiter(void 0, void 0, void 0, function* () {
    const pointDelta = Number(yield pool.methods.pointDelta().call());
    return pointDelta;
});
exports.getPointDelta = getPointDelta;
const getPoolState = (pool) => __awaiter(void 0, void 0, void 0, function* () {
    const { sqrtPrice_96, currentPoint, observationCurrentIndex, observationQueueLen, observationNextQueueLen, liquidity, liquidityX } = yield pool.methods.state().call();
    return {
        sqrtPrice_96: sqrtPrice_96.toString(),
        currentPoint: Number(currentPoint),
        observationCurrentIndex: Number(observationCurrentIndex),
        observationQueueLen: Number(observationQueueLen),
        observationNextQueueLen: Number(observationNextQueueLen),
        liquidity: liquidity.toString(),
        liquidityX: liquidityX.toString()
    };
});
exports.getPoolState = getPoolState;
